import React, { CSSProperties, FC, useState } from 'react';
import cls from 'classnames';
import { ContentPadding, ExpandItemProps } from './ExpandItem.types';
import { getClassNames, getRootClassListFromProps } from '../../../utilities/classNames';
import { CaretDownIcon, CaretUpIcon } from '@stashinvest/react-assets';
export const classNames = getClassNames('sds-expand-item', ['header', 'content']);

const mapPaddingToClassName: Record<ContentPadding, string> = {
	small: 'px-contentSmall py-content2XS',
	medium: 'px-contentMedium py-content2XS',
};

const ExpandItem: FC<ExpandItemProps> = (props) => {
	const { className, children, header, contentPadding = 'medium' } = props;

	const [isExpanded, setExpanded] = useState(false);
	return (
		<div className={cls(getRootClassListFromProps(classNames, props), className)}>
			<button onClick={() => setExpanded(!isExpanded)}
			aria-expanded={isExpanded}
			aria-label={`Expand ${header}`}
			>
				<div className={cls(classNames.header, mapPaddingToClassName[contentPadding])}>
					<span>{header}</span>
					{isExpanded ? <CaretUpIcon className="flex-none" size="XS" /> : <CaretDownIcon className="flex-none" size="XS" />}
				</div>
			</button>
			{isExpanded && (
				<div className={cls(classNames.content, mapPaddingToClassName[contentPadding])}>
					{children}
				</div>
			)}
		</div>
	);
};

ExpandItem.displayName = 'ExpandItem';

export default ExpandItem;
